import { Component } from '@angular/core';

/**
 * Privacy Policy, served at /privacy.
 *
 * Public and unlinked by design — the URL is supplied to third parties during
 * app review (Intuit requires a privacy policy URL) and must be readable by
 * anyone without signing in.
 */
@Component({
  selector: 'bhub-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: false
})
export class PrivacyPolicyComponent {
  readonly effectiveDate = 'September 3, 2026';
}
